import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Layout, Row, Col, Rate, Table, Button, Card } from 'antd';
import { Link } from 'react-router-dom';
import { supplierFacilitiesRestCrudThunksForSupplier } from '../../thunks/supplier_facilities_thunks';
import { getRecordsForTargetCollection } from '../../reducers/standard_reducer_utils';
import { AddressDisplay } from '../address_display/AddressDisplay';
import { FlexibleImageAvatar } from '../flexible-image-avatar/FlexibleImageAvatar';
import LogOnMountWithStandardEventProperties from '../log_on_mount_with_standard_event_properties/LogOnMountWithStandardEventProperties';
import queryString from 'querystring';

const SUPPLIER_FACILITIES_COLLECTION_NAME = 'supplierFacilitiesAdminPanel';

const { Content } = Layout;

const style = require('./SupplierAdminFacilitiesPage.less');

const initState = {
	filteredInfo: null,
	sortedInfo: null,
	visible: false,
	invitedUsers: new Set([]),
};

interface SourcingPageState {
	filteredInfo: any;
	sortedInfo: any;
	visible: boolean;
	invitedUsers: any;
}

class SupplierAdminFacilitiesPage extends React.Component<any, SourcingPageState> {
	formRefs: any;
	initialPagination: any = {
		current: 1,
		pageSize: 10,
		showSizeChanger: true,
		pageSizeOptions: ['5', '10', '25', '50'],
		onChange: (current, size) => this.handleSizeChange(current, size),
	};
	constructor(props) {
		super(props);
		this.state = {
			...initState,
		};
		const { location } = this.props;
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);
		const { current, pageSize, ...other } = queryParams;
		this.initialPagination = {
			...this.initialPagination,
			current: current ? current : this.initialPagination.current,
			pageSize: pageSize ? pageSize : this.initialPagination.pageSize,
		};
		this.handleChange = this.handleChange.bind(this);
		this.clearFilters = this.clearFilters.bind(this);
		this.clearAll = this.clearAll.bind(this);
		this.formRefs = {
			userInviteForm: null,
		};
	}

	componentDidMount() {
		const { fetchSupplierFacilities } = this.props;
		fetchSupplierFacilities();
	}
	handleSizeChange = (current, size) => {
		const { history, location, fetchSupplierFacilities } = this.props;
		let backUrl = `/supplier/admin/facilities?`;
		let searchParams = new URLSearchParams(location.search);
		searchParams.set('current', current);
		searchParams.set('pageSize', size);
		history.push(backUrl.concat(searchParams.toString()));
		this.initialPagination = { ...this.initialPagination, current: current, pageSize: size };
		fetchSupplierFacilities();
	};

	handleChange(pagination, filters, sorter) {
		this.setState({
			filteredInfo: filters,
			sortedInfo: sorter,
		});
	}

	clearFilters() {
		this.setState({ filteredInfo: null });
	}

	clearAll() {
		this.setState({
			filteredInfo: null,
			sortedInfo: null,
		});
	}

	render() {
		let filteredInfo = this.state.filteredInfo || {};
		let sortedInfo = this.state.sortedInfo || {};
		const { history, supplierFacilities, currentUser } = this.props;
		const { invitedUsers } = this.state;
		const supplierFacilitiesRecords = getRecordsForTargetCollection(
			supplierFacilities,
			SUPPLIER_FACILITIES_COLLECTION_NAME
		);

		const columns = [
			{
				title: 'Name',
				dataIndex: 'displayName',
				render: (text, record) => (
					<Link to={`/supplier/company/${record.id}`}>
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<div style={{ marginRight: 16 }}>
								<FlexibleImageAvatar
									displayName={text}
									showPopover={false}
									popoverText={text}
									width="64px"
									height="64px"
									imageUrl={record.logoURL}
								/>
							</div>
							<div>
								<div style={{ fontSize: 18, wordBreak: 'break-word' }}>{text}</div>
								<div style={{ minWidth: 140 }}>
									<Rate disabled={true} allowHalf={true} value={record.averageRatings} />
								</div>
							</div>
							<div style={{ marginLeft: 24, color: 'rgba(0,0,0,0.45)' }}>
								<AddressDisplay address={record.primaryAddress} />
							</div>
						</div>
					</Link>
				),
			},
			{
				title: '',
				dataIndex: 'id',
				render: (text, record) => (
					<Button onClick={() => history.push(`/supplier/admin/facilities/${text}/edit`)}>
						Edit
					</Button>
				),
			},
		];

		return (
			<Content className="adminFacilitiesPage" style={{ padding: '0 0.5em' }}>
				<LogOnMountWithStandardEventProperties eventType="visited supplier admin facilities page" />
				{/*<ScrollToTopOnMount/>*/}
				{/*<BackTop/>*/}

				<Row style={{ margin: '0.5em -8px' }} gutter={16}>
					<Col span={24}>
						<Card
							bodyStyle={{ padding: 8 }}
							title="Facilities"
							extra={
								<Button
									type="primary"
									style={{ position: 'absolute', right: 24, top: 13 }}
									onClick={() => history.push('/supplier/admin/facilities/new')}
								>
									Add Facility
								</Button>
							}
						>
							<Table
								showHeader={false}
								columns={columns}
								dataSource={supplierFacilitiesRecords}
								loading={supplierFacilities.loading}
								pagination={this.initialPagination}
							/>
						</Card>
					</Col>
				</Row>
			</Content>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,

	supplierFacilities: state.supplier_facilities,
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
	fetchSupplierFacilities: () =>
		dispatch(
			supplierFacilitiesRestCrudThunksForSupplier.read({}, SUPPLIER_FACILITIES_COLLECTION_NAME)
		),
	updateSupplierFacility: (facility) =>
		dispatch(supplierFacilitiesRestCrudThunksForSupplier.update(facility)),
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(SupplierAdminFacilitiesPage)
);
